import { motion } from 'motion/react';
import { Skeleton } from '@/components/ui/skeleton';
import { AnimatedNumber } from '@/components/orders-drilldown/animated-number';

export interface DrilldownStat {
  label: string;
  value: number;
  format: (value: number) => string;
}

interface OrdersDrilldownStatsProps {
  /** Null while loading. */
  stats: DrilldownStat[] | null;
}

/** KPI strip: the numbers that must match the card the user clicked. */
export function OrdersDrilldownStats({ stats }: OrdersDrilldownStatsProps) {
  return (
    <dl className="flex flex-wrap gap-3">
      {(stats ?? [null, null, null]).map((stat, index) => (
        <motion.div
          key={stat?.label ?? index}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 + index * 0.07, duration: 0.35 }}
          className="min-w-[130px] rounded-lg border border-border bg-muted/30 px-3 py-1.5"
        >
          <dt className="text-xs text-muted-foreground">
            {stat?.label ?? <Skeleton className="h-3 w-16" />}
          </dt>
          <dd className="text-base font-semibold leading-tight tracking-tight">
            {stat ? (
              <AnimatedNumber value={stat.value} format={stat.format} />
            ) : (
              <Skeleton className="mt-1 h-5 w-20" />
            )}
          </dd>
        </motion.div>
      ))}
    </dl>
  );
}
